/** @Flow */
import i18n from 'statsradio/i18n/i18n';

export type DayOfWeek =
| 'MONDAY'
| 'TUESDAY'
| 'WEDNESDAY'
| 'THURSDAY'
| 'FRIDAY'
| 'SATURDAY'
| 'SUNDAY'

export const ISO_DAYS: { [day: DayOfWeek]: number } = {
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
};

export const DAY_RENDER_FORMAT = {
  LONG: 'LONG',
  SHORT: 'SHORT',
};

export function translate(day: DayOfWeek, renderFormat: DAY_RENDER_FORMAT) {
  if (renderFormat === DAY_RENDER_FORMAT.SHORT) {
    return i18n.t(`dayOfWeek.short.${day.toLowerCase()}`);
  }
  return i18n.t(`dayOfWeek.${day.toLowerCase()}`);
}



// WEBPACK FOOTER //
// ./src/common/domain/DayOfWeek.js